'use client';
import { createUnitParser } from '../../../modules/units/impl/createUnitParser/createUnitParser.js';
import { rem } from '../../../modules/sizes/impl/units/units.js';

const space = ({ unitSpace })=>{
    return createUnitParser({
        suffix: 's',
        parseUnit: (value)=>{
            if (value == null) {
                return undefined;
            }
            return rem(unitSpace * Number(value));
        }
    });
};

export { space };
//# sourceMappingURL=space.js.map
